import CommonStatus from './CommonStatus';

export default class Dod extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { status, failureCallback } = this.props;
        switch(status) {
            case 409:
            case 410:
            case 412: 
                return <CommonStatus {...this.props} 
                    preComponentCallback={() => { if (failureCallback) failureCallback(status); }}
                />;

            default: return <CommonStatus status={status} />;
        }
    }
}